import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import { type UserResource, UserTypeEnum } from "@exonn/js-sdk";

export const module: Module<UserResource> = {
  id: ResourceEnum.User,
  bigIcon: <i className="icon-20-customers_adm" />,
  smallIcon: <i className="icon-15-customers_adm" />,
  name: (t: TFunction) => t("moduleName.users"),
  list: {
    hideDeleteAction: (row) => {
      return [UserTypeEnum.Developer, UserTypeEnum.Owner].includes(
        row.user_type,
      );
    },
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
};
